import {
  HTTP_GETFILES_FETCHING,
  HTTP_GETFILES_SUCCESS,
  HTTP_GETFILES_FAILED,
} from "././../../Constants";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_GETFILES_FETCHING:
      return {
        ...state,
        result: null,
        isFetching: true,
        isError: false,
      };
    case HTTP_GETFILES_SUCCESS:
      return {
        ...state,
        result: payload,
        isFetching: false,
        isError: false,
      };
    case HTTP_GETFILES_FAILED:
      return {
        ...state,
        result: null,
        isFetching: false,
        isError: true,
      };
    default:
      return state;
  }
};
